<template>
  <svg class="flute-bird" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <ellipse cx="30" cy="36" rx="18" ry="14" fill="#7dd3fc" />
    <ellipse cx="30" cy="36" rx="18" ry="14" fill="none" stroke="#38bdf8" stroke-width="2" />
    <circle cx="42" cy="24" r="10" fill="#bae6fd" />
    <circle cx="42" cy="24" r="10" fill="none" stroke="#38bdf8" stroke-width="2" />
    <circle cx="45" cy="22" r="2.2" fill="#0f172a" />
    <path d="M50 24 L60 22 L50 28 Z" fill="#fbbf24" />
    <path d="M16 34 Q4 28 8 40 Q14 42 16 38 Z" fill="#38bdf8" />
    <path d="M28 48 L24 58 L30 54 L34 58 L32 48 Z" fill="#fbbf24" />
    <path d="M34 14 L38 4 L42 14" fill="none" stroke="#f472b6" stroke-width="2" stroke-linecap="round" />
    <circle cx="38" cy="3" r="2.5" fill="#f472b6" />
  </svg>
</template>

<script>
export default {
  name: 'FluteBird'
}
</script>

<style scoped>
.flute-bird {
  width: 100%;
  height: 100%;
  display: block;
  filter: drop-shadow(0 4px 8px rgba(56, 189, 248, 0.55));
}
</style>
